import { Injectable } from '@angular/core';

export interface Menu {
  state: string;
  name: string;
  type: string;
  icon: string;
}

const MENUITEMS = [
  { state: 'ctacte', name: 'Cta Cte', type: 'link', icon: 'event_note' },
  { state: 'afiliados', name: 'Medicos', type: 'link', icon: 'supervisor_account' },
  { state: 'prestaciones', name: 'Beneficios', type: 'link', icon: 'description' },
  { state: 'movimientos-prestaciones', name: 'Mov. Prestaciones', type: 'link', icon: 'search' },
  { state: 'farmacias', name: 'Farmacias', type: 'link', icon: 'local_pharmacy' },
];

@Injectable()
export class MenuItems {
  getMenuitem(): Menu[] {
    return MENUITEMS;
  }
}
